
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';

export const ADD_REFNO = '[REFNO] Add';
export const REMOVE_REFNO = '[REFNO] Remove';
export const EDIT_REFNO = '[REFNO] Edit';
// AddReferenceNumber
export class AddReferenceNumber implements Action {
    readonly type = ADD_REFNO;

    constructor(public payload: RefNo) { }
}
// RemoveReferenceNumber
export class RemoveReferenceNumber implements Action {
    readonly type = REMOVE_REFNO;

    constructor(public payload: number) { }
}
// EditReferenceNumber
export class EditReferenceNumber implements Action {
    readonly type = EDIT_REFNO;

    constructor(public payload: number) { }
}

export type Actions = AddReferenceNumber | RemoveReferenceNumber | EditReferenceNumber;
